<template>
  <v-container>
    <v-row class="text-center">
      <v-col class="mb-4">
        <h2 class="font-weight-bold mb-3">Hello (Cyber) World</h2>

        <p class="subheading font-weight-regular">Kuswandanu Kusuma Wicaksana</p>
      </v-col>

      <v-col class="mb-5" cols="12">
        <h2 class="headline font-weight-bold mb-3">
          <span class="text-decoration-line-through">Important</span> Links
        </h2>

        <v-row justify="center">
          <a
            v-for="(link, i) in importantLinks"
            :key="i"
            :href="link.href"
            class="subheading mx-3"
            target="_blank"
          >{{ link.text }}</a>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { functions } from "@/firebase";
// import { data } from "@/firebase";

export default {
  name: "HelloWorld",

  data: () => ({
    importantLinks: [
      {
        text: "Facebook",
        href: "https://facebook.com/kuswandanu",
      },
      {
        text: "Instagram",
        href: "https://instagram.com/kuswandanu",
      },
      {
        text: "Twitter",
        href: "https://twitter.com/kuswandanu",
      },
      {
        text: "Github",
        href: "https://github.com/kuswandanu",
      },
      {
        text: "Tumblr",
        href: "https://kuswandanu.tumblr.com",
      },
    ],
  }),
  created() {
    const hit = functions.httpsCallable("hit");
    hit().then(function () {});
  },
};
</script>
